import { render } from "./AwardsPage.vue?vue&type=template&id=15038912"
import script from "./AwardsPage.vue?vue&type=script&lang=js"
export * from "./AwardsPage.vue?vue&type=script&lang=js"

import "./AwardsPage.vue?vue&type=style&index=0&id=15038912&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__